import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const ScoreOutlined = props => (
  <SvgIcon viewBox="0 0 18 18" fill="none" {...props}>
    <defs>
      <path
        id="ascr"
        d="M0 0h18v13.886H0z"
      />
    </defs>
    <g
      fill="none"
      fillRule="evenodd"
      transform="translate(0 2)"
    >
      <mask id="bscr">
        <use xlinkHref="#ascr" />
      </mask>
      <path
        fill="currentcolor"
        d={
        `M14.657 12.343a.257.257 0 0 1-.257.257h-2.571a.256.256 0
        0 1-.257-.257v-10.8c0-.143.114-.258.257-.258H14.4c.142
        0 .257.115.257.257v10.801zm-4.436 0c0 .142-.102.257-.23.257H7.687c-.127
        0-.229-.115-.229-.257V4.628c0-.142.102-.257.229-.257h2.304c.128
        0 .23.115.23.257v7.715zm-4.049 0c0 .142-.106.257-.237.257H3.579c-.131
        0-.236-.115-.236-.257v-3.6c0-.143.105-.257.236-.257h2.356c.131
        0 .237.114.237.257v3.6zm11.104.282h-1.028a.257.257
        0 0 1-.257-.257L15.943.514A.515.515 0 0 0 15.428 0h-4.627a.514.514
        0 0 0-.515.514v2.314a.257.257 0 0 1-.257.257H6.686a.515.515
        0 0 0-.514.515v3.343a.258.258 0 0 1-.257.257H2.571a.514.514
        0 0 0-.514.514v4.566a.257.257 0 0 1-.256.257H.771c-.425 0-.771.222-.771.647
        0 .426.346.702.771.702h16.457c.425 0 .772-.206.772-.63 0-.427-.299-.63-.724-.63z`
      }
      />
    </g>
  </SvgIcon>
);

export default ScoreOutlined;
